'use strict';

const shadows = {
    default: '0px 1px 6px 0px rgba(147, 163, 192, 0.25)',
};

exports.shadows = shadows;
//# sourceMappingURL=shadows.js.map
